import { render, staticRenderFns } from "./PantsCertificationFilters.vue?vue&type=template&id=565317d0&scoped=true"
import script from "./PantsCertificationFilters.vue?vue&type=script&lang=js"
export * from "./PantsCertificationFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565317d0",
  null
  
)

export default component.exports